import React, { useState } from "react";
import Footer from "../Footer/Footer";
import About from "../Sections/About/About";
import Header from "../Sections/About/Header/Header";
import FreeApp from "../Sections/Download/FreeApp";
const AboutUs = () => {
  const initialScale = 1;
  const minScale = 0.3;
  const maxScroll = 300;
  const [scrollOffset, setScrollOffset] = useState(0);

  const scrollFactor = Math.min(scrollOffset / maxScroll, 1);
  const scale = initialScale - (initialScale - minScale) * scrollFactor;

  const borderRadius = scale > minScale ? 32 * scrollFactor : 0;

  return (
    <>
      <Header></Header>
      <About></About>
      <FreeApp></FreeApp>
      <Footer></Footer>
    </>
  );
};
export default AboutUs;
